<!-- 轮播广告 -->
<template>
    <div v-if="componentsData.type == 2" :style="`padding: ${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px;`" >
        <div class="swiper-container" >
            <Carousel radius-dot dots="inside">
                <CarouselItem v-for="(item, index) of componentsData.content.bannerList" :key="index" :style="`height: ${componentsData.content.height}px;`" >
                    <img class="wh100" :src="item.picview"
                        :style="componentsData.content.version ? 
                            `border-radius: ${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.bottom}px ${componentsData.content.radiusData.bottom}px;` :
                            `border-radius: ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.bottomRadius}px ${componentsData.content.marginData.bottomRadius}px;`
                        "                    
                    />
                </CarouselItem>
            </Carousel>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
        bg_color: {
            type: String,
            default: "#fff",
        },
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style scoped>
.swiper-container {
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    z-index: 1;
}
.wh100 {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}
</style>